import { getCurrentUser } from './index';

export async function getCurrentUserOwnedAccountId(): Promise<number | undefined> {
  const currentUser = await getCurrentUser();

  if (currentUser) {
    return currentUser.accounts?.[0]?.id;
  }

  return undefined;
}
